import type { ITableCellSelection } from "@library-elements/table";
import { TABLE_CELL_SELECTION_THICKNESS as SEL_THICK } from "../constants";

interface IProps {
  tableWrapperEl: HTMLElement;
  //
  tableCols: number;
  tableRows: number;
  //
  startCellEl?: HTMLElement;
  endCellEl?: HTMLElement;
  cellsIds: string[];
}

export const tableCreateCellsSelection = (
  props: IProps,
): ITableCellSelection | null => {
  const { cellsIds, tableWrapperEl, startCellEl } = props;
  const wrapperRect = tableWrapperEl.getBoundingClientRect();

  if (!(startCellEl instanceof HTMLElement)) {
    return null;
  }

  const startCellId = startCellEl.getAttribute("data-cell-id");
  const startCol = Number(startCellEl.getAttribute("data-cell-col"));
  const startRow = Number(startCellEl.getAttribute("data-cell-row"));

  if (!startCellId || Number.isNaN(startCol) || Number.isNaN(startRow)) {
    return null;
  }

  const endCellEl = props.endCellEl ?? startCellEl;
  const endCellId = endCellEl.getAttribute("data-cell-id");
  const endCol = Number(endCellEl.getAttribute("data-cell-col"));
  const endRow = Number(endCellEl.getAttribute("data-cell-row"));

  if (!endCellId || Number.isNaN(endCol) || Number.isNaN(endRow)) {
    return null;
  }

  const startRect = startCellEl.getBoundingClientRect();
  let x = startRect.x - wrapperRect.x;
  let y = startRect.y - wrapperRect.y;
  let width = startRect.right - startRect.left;
  let height = startRect.bottom - startRect.top;

  if (startCellEl !== endCellEl) {
    const endRect = endCellEl.getBoundingClientRect();
    width = endRect.right - startRect.left;
    height = endRect.bottom - startRect.top;
  }

  let startCellWidth = startRect.width;
  let startCellHeight = startRect.height;

  let wAdjust: number;
  if (startCol === 0) {
    wAdjust = SEL_THICK / 2;
    x -= wAdjust;
  } else {
    wAdjust = SEL_THICK;
  }

  startCellWidth += wAdjust;
  width += startCol === endCol ? wAdjust : SEL_THICK;

  if (startCol !== 0 && startCol === endCol) {
    x -= SEL_THICK / 2;
  }

  let hAdjust: number;
  if (startRow === 0) {
    hAdjust = SEL_THICK;
    y -= hAdjust / 2;
  } else {
    hAdjust = SEL_THICK;
  }

  startCellHeight += hAdjust;
  height += startRow === endRow ? hAdjust : SEL_THICK;

  if (startRow !== 0 && startRow === endRow) {
    y -= SEL_THICK / 2;
  }

  return {
    cellsIds,
    //
    startCellId,
    endCellId,
    //
    startCellEl,
    endCellEl,
    //
    startCol,
    startRow,
    endCol,
    endRow,
    //
    x,
    y,
    width,
    height,
    //
    startCellDimensions: {
      width: startCellWidth,
      height: startCellHeight,
    },
  };
};
